export function normalizeEntityIdentifier(
  value: unknown
): string | undefined {
  if (typeof value === 'string') {
    const trimmedValue = value.trim();
    return trimmedValue.length > 0 ? trimmedValue : undefined;
  }

  if (typeof value === 'number') {
    return String(value);
  }

  if (typeof value === 'object' && value !== null) {
    const mongoObjectId = (value as { $oid?: unknown }).$oid;
    if (typeof mongoObjectId === 'string') {
      const trimmedObjectId = mongoObjectId.trim();
      return trimmedObjectId.length > 0 ? trimmedObjectId : undefined;
    }

    const stringifiedValue = String(value);
    if (stringifiedValue && stringifiedValue !== '[object Object]') {
      return stringifiedValue;
    }
  }

  return undefined;
}
